<h3>
	<i
		[class]="icon"
		[ngStyle]="{
			color: iconColor,
		}"
	></i>
	{{ title }}
</h3>

<span>
	<ng-content />
</span>
